import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6 mt-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "required",
  for: ""
}, "Input json", -1)
const _hoisted_5 = { class: "col-lg-6 mt-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "required",
  for: ""
}, "Input json", -1)
const _hoisted_7 = { class: "bg-primary" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", null, "Merge Json Object", -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-lg-6 mt-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "required",
  for: ""
}, "Original Lang Json", -1)
const _hoisted_12 = { class: "col-lg-6 mt-5" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "required",
  for: ""
}, "Newly Translated", -1)
const _hoisted_14 = { class: "col-lg-12 mt-5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "required",
  for: ""
}, "Merged", -1)

import { onMounted, ref } from "vue";
import Clipboard from "clipboard";

export default /*#__PURE__*/_defineComponent({
  __name: 'UsefulScript',
  setup(__props) {

const jsonInput = ref("");
const pendingTranslateObject = ref({});

const mergeJson1 = ref("");
const mergeJson2 = ref("");
const mergedJson = ref("");

const languages = ref<Array<string>>([]);

const allLangDataObjects = ref<any>({});

const activeLang = ref("en-us");
const handleLangSelect = (lang) => {
  activeLang.value = lang;
  console.log(allLangDataObjects.value);
  mergeJson1.value = JSON.stringify(allLangDataObjects.value[lang]);
};

const mergeJsonHandler = () => {
  const obj1 = JSON.parse(mergeJson1.value);
  const obj2 = JSON.parse(mergeJson2.value);
  const strVal = JSON.stringify(deepMerge(obj1, obj2));
  mergedJson.value = strVal;
  Clipboard.copy(strVal);
};

const getData = () => {
  //

  const jsonFiles = require.context("@/locales", true, /\.json$/);
  const fileKeys = jsonFiles.keys();
  languages.value = fileKeys.map((key) =>
    key.replace(/^\.\//, "").replace(/\.json$/, "")
  );
  const jsonFileData = {};

  fileKeys.forEach((key) => {
    const fileName = key.replace(/^\.\//, "").replace(/\.json$/, "");
    jsonFileData[fileName] = jsonFiles(key);
  });

  const { untranslatedMap } = findUntranslatedKeys(
    jsonFileData["en-us"],
    jsonFileData
  );
  // console.log(untranslatedKeys);
  // console.log(untranslatedMap);
  const pendingTranslationObj = createPendingTranslateObject(untranslatedMap);
  pendingTranslateObject.value = pendingTranslationObj;
  console.log(pendingTranslationObj);
  mergeJson2.value = JSON.stringify(pendingTranslationObj);

  const str =
    "将下面的json object翻译成如下几种语言：印尼语，日语，蒙古语，马来语，泰语，越南语，简体中文，繁体中文，每种语言一种一种返回，而且都返回一样的json object：\n\n" +
    mergeJson2.value;
  Clipboard.copy(str);
};

function findUntranslatedKeys(enUsData, translationDatas) {
  const untranslatedKeys = Array<any>();
  const untranslatedMap = new Map();

  function traverseObject(obj, translationObj, path = "") {
    for (const key in obj) {
      const currentPath = path ? `${path}.${key}` : key;
      const enUsValue = obj[key];
      const translationValue = translationObj[key];
      // if (currentPath === "fields.nativeName") {
      //   console.log(currentPath);
      // }
      if (
        typeof enUsValue === "object" &&
        typeof translationValue === "object"
      ) {
        traverseObject(enUsValue, translationValue, currentPath);
      } else if (
        typeof enUsValue !== "object" &&
        (translationValue === undefined ||
          /~/.test(translationValue) ||
          translationValue === "" ||
          translationValue === null)
      ) {
        untranslatedMap.set(currentPath, getEngByKey(enUsData, currentPath));
        untranslatedKeys.push(currentPath);
      }
    }
  }

  Object.keys(translationDatas).map((key) => {
    if (key === "en-us") return;
    const langData = translationDatas[key];
    traverseObject(enUsData, langData);
  });

  return { untranslatedKeys, untranslatedMap };
}

function getEngByKey(engLang: object, engKey: string) {
  const keys = engKey.split(".");

  //
  function getValueFromObj(obj: object, idx: number) {
    if (idx >= keys.length) {
      throw new Error("Length exceed");
    }
    const key = keys[idx];
    if (typeof obj[key] === "string") return obj[key];
    if (typeof obj[key] === "object") return getValueFromObj(obj[key], idx + 1);
    throw new Error("Not found, please check code");
  }

  return getValueFromObj(engLang, 0);
}

function createPendingTranslateObject(untranslatedMap: Map<string, string>) {
  const pendingTranslateObject = {};

  function helper(
    obj: object,
    value: string,
    idx: number,
    keys: Array<string>
  ) {
    const key = keys[idx];
    if (!obj[key]) {
      obj[key] = {};
    }
    if (idx === keys.length - 1) {
      obj[keys[idx]] = value;
      return;
    }
    helper(obj[key], value, idx + 1, keys);
  }

  untranslatedMap.forEach((translation, keyString) => {
    const keys = keyString.split(".");
    helper(pendingTranslateObject, translation, 0, keys);
  });
  return pendingTranslateObject;
}

function isObject(item) {
  return item && typeof item === "object" && !Array.isArray(item);
}

function deepMerge(obj1, obj2) {
  let target = {};
  for (let key in obj1) {
    if (isObject(obj1[key])) {
      if (key in obj2 && isObject(obj2[key])) {
        target[key] = deepMerge(obj1[key], obj2[key]);
      } else {
        target[key] = obj1[key];
      }
    } else if (obj1[key] !== "" || (key in obj2 && obj2[key] === "")) {
      target[key] = obj1[key];
    }
  }

  for (let key in obj2) {
    if (!(key in obj1)) {
      target[key] = obj2[key];
    } else if (
      !isObject(obj2[key]) &&
      obj2[key] !== "" &&
      (obj1[key] === "" || !isObject(obj1[key]))
    ) {
      target[key] = obj2[key];
    }
  }

  return target;
}

const writeBackToJson = () => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  // const fs = require("fs");
  // console.log("write back to json");
};

onMounted(() => {
  // getData();
  const jsonFiles = require.context("@/locales", true, /\.json$/);
  languages.value = jsonFiles
    .keys()
    .map((key) => key.replace(/^\.\//, "").replace(/\.json$/, ""));

  jsonFiles.keys().forEach((key) => {
    const fileName = key.replace(/^\.\//, "").replace(/\.json$/, "");
    allLangDataObjects.value[fileName] = jsonFiles(key);
  });
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: getData
      }, "Get Untranslated"),
      _createTextVNode(" 将下面的json object翻译成如下几种语言：印尼语，日语，蒙古语，马来语，泰语，越南语，简体中文，繁体中文，每种语言一种一种返回，而且都返回一样的json object： "),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_el_input, {
            type: "textarea",
            rows: 10,
            modelValue: jsonInput.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((jsonInput).value = $event)),
            placeholder: "Input json"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(pendingTranslateObject.value), 1)
        ])
      ])
    ]),
    _createElementVNode("button", {
      class: "btn btn-primary",
      onClick: writeBackToJson
    }, "Write Back"),
    _createElementVNode("div", null, [
      _hoisted_8,
      _createVNode(_component_el_menu, {
        "default-active": activeLang.value,
        class: "el-menu-demo mb-5",
        mode: "horizontal",
        onSelect: handleLangSelect
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (lang) => {
            return (_openBlock(), _createBlock(_component_el_menu_item, {
              index: lang,
              key: lang
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(lang), 1)
              ]),
              _: 2
            }, 1032, ["index"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["default-active"]),
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: mergeJsonHandler
      }, "Merge"),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_el_input, {
            type: "textarea",
            rows: 10,
            modelValue: mergeJson1.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((mergeJson1).value = $event)),
            placeholder: "Input json"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_el_input, {
            type: "textarea",
            rows: 10,
            modelValue: mergeJson2.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((mergeJson2).value = $event)),
            placeholder: "Input json"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_el_input, {
            type: "textarea",
            rows: 10,
            modelValue: mergedJson.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((mergedJson).value = $event)),
            placeholder: "Input json"
          }, null, 8, ["modelValue"])
        ])
      ])
    ])
  ], 64))
}
}

})